<template>
  <div>
    <!-- 화면 타이틀 -->
    <v-row class="title-wrap" fixed>
      <v-col cols="12" class="icon-title word-type pa-4">
        <icon-work-day :width="22" :height="22" />일정
      </v-col>
    </v-row>

    <!-- 캘린더 -->
    <calendar-appl class="overflow-y-auto overflow-x-hidden"></calendar-appl>
  </div>
</template>

<script>
/* 일정 */
import CalendarAppl from '@/components/calendar/CalendarAppl.vue';
import IconWorkDay from '@/assets/customIcon/IconWorkDay.vue';

export default {
  data: () => ({}),
  components: {
    CalendarAppl,
    IconWorkDay,
  },
};
</script>

<style>
/* #create .v-speed-dial {
  position: absolute;
} */
.v-calendar-weekly__head .v-past,
.v-calendar-weekly__head .v-future,
.v-calendar-weekly__head .v-present {
  border-bottom: 1px solid #e0e0e0;
}
.v-application .v-present .primary {
  background-color: #087ef7 !important;
}
.v-calendar.v-calendar-events .v-calendar-weekly__head-weekday {
  /* margin-right: -1px; */
  margin-right: 0px !important;
  color: #9ca3ab !important;
}
.v-calendar.v-calendar-events .v-calendar-weekly__day {
  overflow: visible;
  /* margin-right: -1px; */
  margin-right: 0px !important;
}
.v-calendar.v-calendar-events .v-calendar-weekly__head-weekday:last-child,
.v-calendar.v-calendar-events .v-calendar-weekly__day:last-child {
  margin-right: -1px !important;
}
.v-application .v-calendar-monthly .v-calendar-weekly__day-label {
  margin-top: 2px;
}
/* 달력 내부 원 사이즈 */
.v-application .v-calendar-monthly .v-size--small {
  width: 34px;
  height: 34px;
}
.v-speed-dial--right {
  right: 24px !important;
}
.v-speed-dial--bottom {
  bottom: 86px !important;
}
</style>
